import { useDroppable } from "@dnd-kit/core";
import { useTranslation } from "react-i18next";

import { classNames } from "utils/common";

export const ELEMENTS_DROP_ZONE_ID = "question-elements-drop-zone";

export const ElementsDropZone = () => {
  const { t } = useTranslation();

  const { setNodeRef, isOver } = useDroppable({ id: ELEMENTS_DROP_ZONE_ID });

  return (
    <div ref={setNodeRef} className={`ElementsDropZone ${classNames({ "is-drop-target": isOver })}`}>
      {t("v8_drop_elements_here", "Drop Elements here")}
    </div>
  );
};
